import { useSelector } from 'react-redux';

import { getPenalties, getRefunds } from 'utils/amountsDueUtils';

import './PenaltiesRefundsCardV2.css';

/**
 * Formats a money amount as dollars and cents with thousands separators.
 *
 * @param {number|string} amount The amount; its sign is dropped.
 * @returns {string} The amount, e.g. "43,221.18".
 */
function formatCurrency(amount) {
	if (amount === null || amount === undefined || amount === '') {
		return '-';
	}
	if (amount === 0) {
		return '$0';
	}
	const num = Math.abs(amount);
	if (num % 1 === 0) {
		return `$${num.toLocaleString('en-US', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		})}`;
	}
	return `$${num.toLocaleString('en-US', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	})}`;
}

function PenaltiesRefundsCard() {
	const { totals } = useSelector((state) => ({
		totals: state.property.propertyData?.totals,
	}));
	let penalties = getPenalties(totals);
	let refunds = getRefunds(totals);

	const rows = [
		{ label: 'ECB Violations', refund: refunds.ecb, penalty: penalties.ecb },
		{ label: 'Facade Filings', refund: refunds.facades, penalty: penalties.facades },
		{ label: 'Electrical', refund: refunds.electrical, penalty: penalties.electrical },
		{ label: 'CityPay Tickets', refund: refunds.citypay, penalty: penalties.citypay },
	];

	return (
		<div className="overview-card-penalties">
			<div className="penalties-row penalties-header">
				<div>Penalties and Refunds</div>
				<div className="penalties-col-refunds">Refunds</div>
				<div className="penalties-col-penalties">Penalties</div>
			</div>
			<div className="penalties-body">
				{rows.map(({ label, refund, penalty }) => (
					<div className="penalties-row" key={label}>
						<div>{label}</div>
						<div className="penalties-col-refunds">{formatCurrency(refund)}</div>
						<div className="penalties-col-penalties">{formatCurrency(penalty)}</div>
					</div>
				))}
			</div>
			<div className="penalties-row penalties-total">
				<div className="penalties-total-label">Total</div>
				<div className="penalties-col-refunds">{formatCurrency(refunds.total)}</div>
				<div className="penalties-col-penalties penalties-total-amount">
					{formatCurrency(penalties.total)}
				</div>
			</div>
		</div>
	);
}

export default PenaltiesRefundsCard;
